import Axios from "axios";
import type { VisitConsentConfirmResponse } from "./visit-consent-public.api";

export type { VisitConsentConfirmResponse } from "./visit-consent-public.api";

export type VisitConsentConfirmPayload = {
  token: string;
  consents: { documentId: string; consented: boolean }[];
  /** PNG image bytes as base64 (no `data:image/png;base64,` prefix). */
  signaturePngBase64: string;
  /** ISO-8601 timestamp for the signing moment shown to the visitor. */
  signedAt: string;
};

/** Submit public visitor consent confirmations for the visit token. */
export const postVisitConsentConfirm = (payload: VisitConsentConfirmPayload) =>
  Axios.post<VisitConsentConfirmResponse>(`/visit/consent/confirm`, payload);
